export class User {
    userId: number;
    userName: string;
}